import React from "react";

export default function Line({ className, name }) {
	return (
		<div
			className={`flex items-center justify-between bg-black px-8 xl:px-16 py-28 ${className}`}
		>
			{/* N */}
			<svg
				width="7"
				height="10"
				viewBox="0 0 7 10"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.08405 2.31486H1.96177V9.61093H0.630272V0.1274H2.58676L5.37204 7.42347H5.49432V0.1274H6.82582V9.61093H4.86933L2.08405 2.31486Z"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* rect */}
			<svg
				width="3"
				height="7"
				viewBox="0 0 3 7"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="0.711517"
					y="0.8703"
					width="1.75313"
					height="5.25938"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* NE */}
			<svg
				width="13"
				height="9"
				viewBox="0 0 13 9"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.11677 2.61606H2.01816V8.49998H0.94437V0.851976H2.52218L4.76837 6.7359H4.86699V0.851976H5.94078V8.49998H4.36296L2.11677 2.61606ZM7.66771 8.49998V0.851976H12.4559V1.88194H8.8949V4.10621H12.3244V5.13618H8.8949V7.47002H12.4559V8.49998H7.66771Z"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* rect */}
			<svg
				width="3"
				height="7"
				viewBox="0 0 3 7"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="0.711517"
					y="0.8703"
					width="1.75313"
					height="5.25938"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* name */}
			<p className="font-medium text-[12px] text-white ">{name}</p>

			<LineItem />

			{/* rect */}
			<svg
				width="3"
				height="7"
				viewBox="0 0 3 7"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="0.711517"
					y="0.8703"
					width="1.75313"
					height="5.25938"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* SE */}
			<svg
				width="13"
				height="9"
				viewBox="0 0 13 9"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M2.92603 8.63144C2.2613 8.63144 1.70249 8.51456 1.2496 8.28081C0.796709 8.04706 0.42417 7.73661 0.131982 7.34947L0.920889 6.59343C1.21308 6.94406 1.52353 7.20337 1.85224 7.37138C2.18095 7.53208 2.55349 7.61243 2.96985 7.61243C3.45196 7.61243 3.82085 7.50286 4.07651 7.28372C4.33948 7.06458 4.47097 6.75048 4.47097 6.34142C4.47097 6.01271 4.37601 5.7607 4.18608 5.58538C3.99616 5.40277 3.6711 5.27128 3.21091 5.19093L2.37817 5.05945C2.01294 5.00101 1.70614 4.90605 1.45778 4.77456C1.20942 4.63577 1.00854 4.47507 0.855146 4.29245C0.701748 4.10253 0.588525 3.89435 0.515478 3.6679C0.449736 3.43415 0.416865 3.18945 0.416865 2.93378C0.416865 2.21062 0.650615 1.66277 1.11812 1.29023C1.58562 0.910383 2.22843 0.720461 3.04655 0.720461C3.65284 0.720461 4.16782 0.819074 4.59149 1.0163C5.02247 1.20622 5.36944 1.4765 5.63241 1.82712L4.86542 2.59411C4.65358 2.33845 4.40157 2.13392 4.10939 1.98052C3.8245 1.81982 3.47022 1.73946 3.04655 1.73946C2.59366 1.73946 2.24669 1.83808 2.00563 2.0353C1.77188 2.22523 1.65501 2.50646 1.65501 2.879C1.65501 3.1931 1.74632 3.44146 1.92894 3.62407C2.11886 3.79939 2.45122 3.92722 2.92603 4.00757L3.73685 4.15001C4.42349 4.27419 4.92386 4.5262 5.23796 4.90605C5.55206 5.27859 5.70911 5.73513 5.70911 6.27568C5.70911 6.6263 5.64702 6.94771 5.52284 7.2399C5.40597 7.53208 5.227 7.78044 4.98595 7.98497C4.7522 8.1895 4.46001 8.35021 4.10939 8.46708C3.76606 8.57665 3.37161 8.63144 2.92603 8.63144ZM7.2169 8.49995V0.851946H12.0051V1.88191H8.44409V4.10618H11.8736V5.13615H8.44409V7.46999H12.0051V8.49995H7.2169Z"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* rect */}
			<svg
				width="3"
				height="7"
				viewBox="0 0 3 7"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect
					x="0.711517"
					y="0.8703"
					width="1.75313"
					height="5.25938"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>

			<LineItem />

			{/* S */}
			<svg
				width="9"
				height="12"
				viewBox="0 0 9 12"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M4.18566 11.795C3.25505 11.795 2.47271 11.6313 1.83867 11.3041C1.20462 10.9768 0.683066 10.5422 0.274004 10.0002L1.37847 8.94175C1.78754 9.43263 2.22216 9.79567 2.68236 10.0309C3.14255 10.2559 3.66411 10.3684 4.24702 10.3684C4.92198 10.3684 5.43842 10.215 5.79635 9.90816C6.1645 9.60137 6.34858 9.16162 6.34858 8.58894C6.34858 8.12874 6.21564 7.77592 5.94975 7.53049C5.68386 7.27482 5.22877 7.09074 4.5845 6.97825L3.41867 6.79417C2.90734 6.71236 2.47783 6.57942 2.13013 6.39534C1.78242 6.20103 1.50119 5.97605 1.28643 5.72038C1.07168 5.45449 0.913164 5.16304 0.810898 4.84601C0.718859 4.51876 0.67284 4.17617 0.67284 3.81824C0.67284 2.80581 1.00009 2.03882 1.65459 1.51727C2.30909 0.985485 3.20903 0.719595 4.3544 0.719595C5.20321 0.719595 5.92418 0.857653 6.51732 1.13377C7.12069 1.39966 7.60645 1.77804 7.97461 2.26892L6.90082 3.34271C6.60425 2.98478 6.25143 2.69844 5.84237 2.48368C5.44353 2.25869 4.94754 2.1462 4.3544 2.1462C3.72036 2.1462 3.23459 2.28426 2.89712 2.56038C2.56987 2.82627 2.40624 3.21999 2.40624 3.74154C2.40624 4.18129 2.53407 4.52899 2.78974 4.78465C3.05563 5.03009 3.52094 5.20906 4.18566 5.32155L5.32081 5.52097C6.28211 5.69482 6.98263 6.04763 7.42237 6.57942C7.86211 7.10097 8.08199 7.74013 8.08199 8.4969C8.08199 8.98777 7.99506 9.43774 7.82121 9.8468C7.65758 10.2559 7.40703 10.6036 7.06956 10.8899C6.74231 11.1763 6.33324 11.4012 5.84237 11.5649C5.36172 11.7183 4.80948 11.795 4.18566 11.795Z"
					fill="white"
					fillOpacity="0.15"
				/>
			</svg>
		</div>
	);
}

function LineItem() {
	return (
		<div
			className="w-2 sm:w-7 md:w-14 h-[1px] sm:h-[1px]
            bg-[rgb(255,255,255,0.15)]"
		/>
	);
}
